export enum DataTrackLabelEnum {
  GameStartMap = 'map_start',
  GameEndMap = 'map_end',
  GameEndAnalysis = 'game_end_analysis',
  TfEndAnalysis = 'tf_end_analysis',
  TerraformGameStart = 'map_start_tf',
  TerraformGameEnd = 'map_end_tf',
  NovaServerAnswer = 'NS-Answer',
  StudentGroupSize = 'Student-GroupSize',
  StudentBoostChoose = 'Student-BoostChoose',
  StudentBoostBought = 'Student-BoostBought',
  StudentNoBoost = 'Student-NoBoost',
  StudentGardenMissionCelebrate = 'Student-GardenMissionCelebrate',
  StudentGardenMissionHarvest = 'Student-GardenMissionHarvest',
  StudentGardenMissionReachedThreshold = 'Student-GardenMissionReachedThreshold',
  StudentItemPurchase = 'Student-ItemPurchase',
  StudentItemEarned = 'Student-ItemEarned',
  StudentMatchEndMarketClick = 'Student-MatchEndMarketClick',
  StudentMatchEndContinueClick = 'Student-MatchEndContinueClick'
}
